import {
    POST_DETAILS_FOR_DELIVERY_SCHEDULE, POST_DETAILS_FOR_DELIVERY_SCHEDULE_ERROR,
    UPDATE_DELIVERY_SCHEDULE_DETAILS, UPDATE_DELIVERY_SCHEDULE_DETAILS_ERROR,
    GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER, GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER_ERROR,
    POST_COMMENTS_FOR_POS, POST_COMMENTS_FOR_POS_ERROR,
    GET_COMMENTS_FOR_POS, GET_COMMENTS_FOR_POS_ERROR,
    GET_DOCUMENTS_FOR_EXPEDITING, GET_DOCUMENTS_FOR_EXPEDITING_ERROR,
    GET_DOCUMENT_DETAILS_FOR_EXPEDITING, GET_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR,
    POST_DOCUMENT_DETAILS_FOR_EXPEDITING, POST_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR,
    UPDATE_APPROVAL_STATUS_FOR_EXPEDITING, UPDATE_APPROVAL_STATUS_FOR_EXPEDITING_ERROR,
    GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING, GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING_ERROR,
    GET_NEXT_ACTION_ROLE_FOR_APPROVAL, GET_NEXT_ACTION_ROLE_FOR_APPROVAL_ERROR,
    GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM, GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM_ERROR,
    GET_EXPEDITING_DOCUMENT_WITH_DETAILS, GET_EXPEDITING_DOCUMENT_WITH_DETAILS_ERROR,
    UPDATE_STATUS_FOR_EXPEDITING, UPDATE_STATUS_FOR_EXPEDITING_ERROR,
    GET_ASSIGNED_ENGINEER_DETAILS, GET_ASSIGNED_ENGINEER_DETAILS_ERROR,
    UPDATE_ENGINEER_ASSIGNMENT_DETAILS, UPDATE_ENGINEER_ASSIGNMENT_DETAILS_ERROR,
    GET_NEXT_ACTED_USERID, GET_NEXT_ACTED_USERID_ERROR,
    GET_DRAWINGS_FOR_EXPEDITING, GET_DRAWINGS_FOR_EXPEDITING_ERROR,
    POST_DRAWING_DOCUMENT_DETAILS, POST_DRAWING_DOCUMENT_DETAILS_ERROR,
    GET_DRAWING_ACTION_DETAILS, GET_DRAWING_ACTION_DETAILS_ERROR,
    POST_ASSIGNED_ENGINEER_DETAILS, POST_ASSIGNED_ENGINEER_DETAILS_ERROR,
    GET_ALL_ASSIGNED_ENGINEER_DETAILS, GET_ALL_ASSIGNED_ENGINEER_DETAILS_ERROR,
    POST_MANUFACTURING_CLEARENCE_DETAILS, POST_MANUFACTURING_CLEARENCE_DETAILS_ERROR,
    GET_MANUFACTURING_CLEARENCE_DETAILS, GET_MANUFACTURING_CLEARENCE_DETAILS_ERROR,
    GET_CLAIM_DETAILS_FOR_EXPEDITING, GET_CLAIM_DETAILS_FOR_EXPEDITING_ERROR,
    POST_PO_TANSMITTLE_DOCUMENT_DETAILS, POST_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR,
    GET_PO_TANSMITTLE_DOCUMENT_DETAILS, GET_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR,
    UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS, UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR,
    PARTIAL_APPROVAL_FOR_EXPEDITING, PARTIAL_APPROVAL_FOR_EXPEDITING_ERROR,
    UPDATE_CLEARENCE_STATUS, UPDATE_CLEARENCE_STATUS_ERROR,
    POST_PROGRESS_REPORT_DOCUMENT_DETAILS, POST_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR,
    GET_PROGRESS_REPORT_DOCUMENT_DETAILS, GET_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR,
    POST_ALL_DOCUMENT_SUBMITTED_STATUS, POST_ALL_DOCUMENT_SUBMITTED_STATUS_ERROR,
    DELETE_ASSIGNED_ENGINEER, DELETE_ASSIGNED_ENGINEER_ERROR,
    GET_ALL_LINE_ITEMS_SP_CASE, GET_ALL_LINE_ITEMS_SP_CASE_ERROR,
    UPDATE_REMARKS, UPDATE_REMARKS_ERROR,
    GET_ALL_DOCUMENTS_FROM_QA, GET_ALL_DOCUMENTS_FROM_QA_ERROR,
    REMOVE_ROW_FROM_DISPLAY_TABLES, REMOVE_ROW_FROM_DISPLAY_TABLES_ERROR,
    POST_CUSTOMER_IC_DATE, POST_CUSTOMER_IC_DATE_ERROR,
    POST_BILLINGSCHEDULECLAIMED, POST_BILLINGSCHEDULECLAIMED_ERROR,
    POST_BG_DETAILS, POST_BG_DETAILS_ERROR,
    GET_BG_DETAILS, GET_BG_DETAILS_ERROR,
    BG_UPLOAD, BG_UPLOAD_ERROR,
    BG_STATUS_UPDATE, BG_STATUS_UPDATE_ERROR,
    BG_Request_ACTION, BG_Request_ACTION_ERROR
} from '../type'
import axios from 'axios';
import env from '../../ENV';

let ROOT_URL = env.BACKEND_URL;

export const postDeliveryScheduleDetails = (params) => async dispatch => {
    console.log(params, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/postdetails-ds/${params.POId}/${params.PoLineItemId}/${params.Documentid}/${params.versionId}`,
        })
        dispatch({
            type: POST_DETAILS_FOR_DELIVERY_SCHEDULE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_DETAILS_FOR_DELIVERY_SCHEDULE_ERROR,
            payload: console.log(e),
        })
    }

}

export const updateDeliveryScheduleDetails = (params) => async dispatch => {
    console.log(params, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/updateDeliveryScheduleDetails`,
            data: params
        })
        dispatch({
            type: UPDATE_DELIVERY_SCHEDULE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_DELIVERY_SCHEDULE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}

export const getallAcceptedDeliveryScheduleDetailforSupplier = (userid, SearchTerm) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}expediting/AcceptedDeliveryScheduleDetail/${userid}/${SearchTerm}`);
        dispatch({
            type: GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER_ERROR,
            payload: console.log(e),
        })
    }
}

export const postCommentsForPOs = (params) => async dispatch => {
    console.log(params, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/pos-comments`,
            data: params
        })
        dispatch({
            type: POST_COMMENTS_FOR_POS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_COMMENTS_FOR_POS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetAllCommentsForPOs = (POId, DocumentId) => async dispatch => {
    console.log(POId, DocumentId, "%%%%")
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}expediting/${POId}/${DocumentId}/get-comments`,
        })
        console.log(res, "Response")
        dispatch({
            type: GET_COMMENTS_FOR_POS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_COMMENTS_FOR_POS_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllDocumentsForExpediting = (id) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}getAllDocumentsForExpediting`)
        dispatch({
            type: GET_DOCUMENTS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENTS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }

}


export const getDocumentDetailsForExpediting = (id, PoLineItemId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}getDocumentDetailsForExpediting/${id}/${PoLineItemId}`)
        dispatch({
            type: GET_DOCUMENT_DETAILS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }
}

export const postDocumentDetailsForExpediting = (params) => async dispatch => {
    console.log(params, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}PostDocumentDetailsForExpediting/${params.POId}/${params.PoLineItemId}/${params.DocumentTypeId}/${params.DocumentId}/${params.DrawingDocumentDetailsid}/${params.approvalStatus}`,
            data: params
        })
        dispatch({
            type: POST_DOCUMENT_DETAILS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }
}

export const approveDocumentsForExpediting = (params) => async dispatch => {
    console.log(params, "data:")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/update-approval-status`,
            data: params
        })
        dispatch({
            type: UPDATE_APPROVAL_STATUS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_APPROVAL_STATUS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetDocumentApprovalDetailsForExpediting = (POId, POLineItemId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}expediting/get-approval-details-for-documents/${POId}/${POLineItemId}`)
        dispatch({
            type: GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetNextActedRoleIdForApproval = (levelId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}/expediting/get-next-team-roleId/${levelId}`)
        dispatch({
            type: GET_NEXT_ACTION_ROLE_FOR_APPROVAL,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_NEXT_ACTION_ROLE_FOR_APPROVAL_ERROR,
            payload: console.log(e),
        })
    }
}

export const getExpeditingStatusIdForPolineItems = (POId, PoLineItemId) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}getExpedingStatusId/${POId}/${PoLineItemId}`)
        dispatch({
            type: GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllDocumentsWithDetailsForExpediting = (documentTypeId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}getAllDocumentsWithDetailsForExpediting/${documentTypeId}`)
        dispatch({
            type: GET_EXPEDITING_DOCUMENT_WITH_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_EXPEDITING_DOCUMENT_WITH_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const UpdateStatusForExpediting = (POId, POLineItemId, StatusId, DocumentId) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}update-status-for-expediting/${POId}/${POLineItemId}/${StatusId}/${DocumentId}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_STATUS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_STATUS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetAssignedEngineers = (PoId, PoLineId, DrawingDocumentDetailsid) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}get-assigned-engineers/${PoId}/${PoLineId}/${DrawingDocumentDetailsid}`)
        dispatch({
            type: GET_ASSIGNED_ENGINEER_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ASSIGNED_ENGINEER_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const UpdateEngineerAssignment = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}edit-engineer-for-expediting/${params.PoId}/${params.PoLineId}/${params.DocumentTypeId}/${params.RoleId}/${params.updatedEngineerId}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_ENGINEER_ASSIGNMENT_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_ENGINEER_ASSIGNMENT_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetNextActedUserId = (levelId, DocumentTypeId, POLineItemId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}get-next-acted-userId/${levelId}/${DocumentTypeId}/${POLineItemId}`)
        dispatch({
            type: GET_NEXT_ACTED_USERID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_NEXT_ACTED_USERID_ERROR,
            payload: console.log(e),
        })
    }

}

export const getAllDrawingDocuments = (params) => async dispatch => {



    try {
        const res = await axios.get(`${ROOT_URL}getAllDrawingDocuments/${params.PoId}/${params.PoLineItemId}`)
        dispatch({
            type: GET_DRAWINGS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DRAWINGS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }

}

export const ApproveDrawingDocuments = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/post-drawing-documents-list`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_DRAWING_DOCUMENT_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_DRAWING_DOCUMENT_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetDrawingDocumentApprovalDetails = (POId, POLineItemId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}get-drawing-action-details/${POId}/${POLineItemId}`)
        dispatch({
            type: GET_DRAWING_ACTION_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DRAWING_ACTION_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetAssignedEngineerDetails = (POId, POLineItemId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}get-assigned-engineers-details/${POId}/${POLineItemId}`)
        dispatch({
            type: GET_ALL_ASSIGNED_ENGINEER_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_ASSIGNED_ENGINEER_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const PostAssignedEngineerDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/post-assigned-engineers-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_ASSIGNED_ENGINEER_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_ASSIGNED_ENGINEER_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const PostManufacturingComment = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/post-manufacturing-clearence-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_MANUFACTURING_CLEARENCE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_MANUFACTURING_CLEARENCE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetAllManufacturingClearenceDetails = (PoLineId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}/get-manufacturing-clearence-details/${PoLineId}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_MANUFACTURING_CLEARENCE_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_MANUFACTURING_CLEARENCE_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetClaimDetailsByPoId = (POId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}get-claim-details/${POId}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_CLAIM_DETAILS_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_CLAIM_DETAILS_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }
}

export const postPoTransmittleDocumnetDtails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/post-po-documents-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_PO_TANSMITTLE_DOCUMENT_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetTransmittalDocumentDetails = () => async dispatch => {
    try{
        const res = await axios.get(`${ROOT_URL}get-document-action-details`)
        dispatch( {
            type: GET_PO_TANSMITTLE_DOCUMENT_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const UpdateTransmittalDocumentDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/update-transmittal-document-action-details`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const PartialApproval = (DrawingDocumentDetailsid, poId, poLineId, RoleId, approvedBy, approvedByName) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}${DrawingDocumentDetailsid}/${poId}/${poLineId}/${RoleId}/${approvedBy}/${approvedByName}/partial-approval`,
            data: ''
        })
        dispatch({
            type: PARTIAL_APPROVAL_FOR_EXPEDITING,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PARTIAL_APPROVAL_FOR_EXPEDITING_ERROR,
            payload: console.log(e),
        })
    }
}
export const updatePOLineItemClearenceStatus = (PoId, PoLineItemId, Status, actedBy) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}${PoId}/${PoLineItemId}/${Status}/${actedBy}/update-clearence-status`,
            data: ''
        })
        dispatch({
            type: UPDATE_CLEARENCE_STATUS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_CLEARENCE_STATUS_ERROR,
            payload: console.log(e),
        })
    }
}

export const InsertProgressReportDocuments = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/post-progress-document-details`,
            data: params
        })
        dispatch({
            type: POST_PROGRESS_REPORT_DOCUMENT_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetProgressReportDocuments = (PoLineItemId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}/${PoLineItemId}/get-progress-document-details`)
        dispatch({
            type: GET_PROGRESS_REPORT_DOCUMENT_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const AllDocumentsSubmittedByVendor = (PoLineItemId, PoId) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}/${PoLineItemId}/${PoId}/all-document-submitted`)
        dispatch({
            type: POST_ALL_DOCUMENT_SUBMITTED_STATUS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_ALL_DOCUMENT_SUBMITTED_STATUS_ERROR,
            payload: console.log(e),
        })
    }
}
export const DeleteAssignedEngineerDetails = (AssignedEngineersForDrawingId) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}/${AssignedEngineersForDrawingId}/delete-assigned-engineer`)
        dispatch({
            type: DELETE_ASSIGNED_ENGINEER,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: DELETE_ASSIGNED_ENGINEER_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetAllPoLineItemsByPoId = (PoId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}/${PoId}/get-all-line-item`)
        dispatch({
            type: GET_ALL_LINE_ITEMS_SP_CASE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_LINE_ITEMS_SP_CASE_ERROR,
            payload: console.log(e),
        })
    }
}

export const UpdateRemarksForPOLineId = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}update-remarks`,
            data: params
        })
        dispatch({
            type: UPDATE_REMARKS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_REMARKS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetAllDocumentsForQA = (POId, PurchaseOrderLineId) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}${POId}/${PurchaseOrderLineId}/get-all-documents-from-qa`)
        dispatch({
            type: GET_ALL_DOCUMENTS_FROM_QA,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_DOCUMENTS_FROM_QA_ERROR,
            payload: console.log(e),
        })
    }
}
export const RemoveRowsFromDocumentTable = (DrawingDocumentDetailsid) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}${DrawingDocumentDetailsid}/remove`,
        })
        dispatch({
            type: REMOVE_ROW_FROM_DISPLAY_TABLES,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: REMOVE_ROW_FROM_DISPLAY_TABLES_ERROR,
            payload: console.log(e),
        })
    }
}
export const postCustomerIcDate = (IcDate, PoLineItemId) => async dispatch => {
    console.log(PoLineItemId, "postCustomerIcDate")
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}${IcDate}/${PoLineItemId}/post-customer-IC-date`,
        })
        dispatch({
            type: POST_CUSTOMER_IC_DATE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_CUSTOMER_IC_DATE_ERROR,
            payload: console.log(e),
        })
    }
}


export const InsertBillingScheduleClaimedDetail = (Input) => async dispatch => {

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expiditing/post-billingscheduleclaim-details`,
            data: Input
        })
        dispatch({
            type: POST_BILLINGSCHEDULECLAIMED,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_BILLINGSCHEDULECLAIMED_ERROR,
            payload: console.log(e),
        })
    }
}
export const postBGListDetails = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/post-BG-details`,
            data: params,
        })
        dispatch({
            type: POST_BG_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_BG_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const getBGListDetails = (input) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/get-BG-details`,
            data: input,
        })
        dispatch({
            type: GET_BG_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_BG_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}
export const uploadBG = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/upload-bg`,
            data: data,
        })

        dispatch({
            type: BG_UPLOAD,
            payload: res.data
        })
        return res.data

    } catch (e) {
        dispatch({
            type: BG_UPLOAD_ERROR,
            payload: e.response,
        })
    }
}

export const UpdateBGStatusforBGRequestRequest = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}expediting/UpdateBGStatus`,
            data: data,
        })

        dispatch({
            type: BG_STATUS_UPDATE,
            payload: res.data
        })
        return res.data

    } catch (e) {
        dispatch({
            type: BG_STATUS_UPDATE_ERROR,
            payload: e.response,
        })
    }
}

export const getactionDetail = (item) => async dispatch => {
    try {
        const res = await axios.post(`${ROOT_URL}GetBgRequestActionDetail`, {data: item});
        console.log(res, "sdhfbksjbsdkfjksdbfbdsf")
        dispatch({
            type: BG_Request_ACTION,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: BG_Request_ACTION_ERROR,
            payload: console.log(e),
        })
    }
}